export default __webpack_public_path__ + "static/media/enghien16.225e501d.jpg";